import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { useClient } from '../../../app/api/client-api';
import { getLiquidityCashWithOtherBanksSettings, type PanelSettingsDto } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';

export function useLiquidityCashWithOtherBanksSettings(): UseQueryResult<PanelSettingsDto, AxiosError> {
    const { data: client } = useClient();
    const queryKey = useMemo(() => queryKeys.liquidityCashWithOtherBanksSettings(client?.partnerUuid), [client?.partnerUuid]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getLiquidityCashWithOtherBanksSettings({ query: { clientId: client!.id }, signal }).then((result) => result.data),
        enabled: !!client,
    });
}
